import _ from 'lodash'
import MetaMenu from '../../all/MetaMenu'
export default _.cloneDeep(MetaMenu).filter((item: any) => item.name !== 'Proveïdors' &&
                                            item.name !== 'Presupostos' && 
                                            item.name !== 'Comandes' &&
                                            item.name !== 'Dades auxiliars' && 
                                            item.name !== 'Almacenes')